import { cn } from '@/modules/shared/lib/utils';

interface GhibliLoaderProps {
  className?: string;
  imageClassName?: string;
  text?: string;
}

export function GhibliLoader({ className, imageClassName, text = "Carregando..." }: GhibliLoaderProps) {
  return (
    <div className={cn("flex flex-col items-center justify-center gap-4 py-12 w-full", className)}>
      <img 
        src="/carregando.webp" 
        alt="Carregando..." 
        loading="eager"
        decoding="async"
        className={cn("w-full max-w-[80vw] h-auto max-h-[60vh] object-contain animate-pulse", imageClassName)}
      />
      
      {/* Loading Text */}
      <p className="font-['Patrick_Hand'] text-slate-600 text-xl animate-pulse">
        {text}
      </p>
    </div>
  );
}

export function MiniGhibliLoader({ className }: { className?: string }) {
  return (
    <div className={cn("relative w-6 h-6 animate-bounce", className)}>
       <div className="absolute inset-0 bg-slate-800 rounded-full blur-[0.5px]" />
       <div className="absolute inset-0 flex items-center justify-center gap-0.5 pt-0.5">
          <div className="w-2 h-2 bg-white rounded-full flex items-center justify-center">
            <div className="w-0.5 h-0.5 bg-black rounded-full" />
          </div>
          <div className="w-2 h-2 bg-white rounded-full flex items-center justify-center">
            <div className="w-0.5 h-0.5 bg-black rounded-full" />
          </div>
       </div>
    </div>
  );
}
